import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { JavaModeHeading } from "../../../../Constant";
import { TYPESCRIPT_DATA } from "../../../../Data/Editors";

const JavaMode = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={JavaModeHeading} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={TYPESCRIPT_DATA} language="javascript">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
};
export default JavaMode;
